const dec2hex = (dec: number): string => dec.toString(16).padStart(2, '0');

/**
 * Генерирует короткую DOM/CSS-безопасную случайную строку (по умолчанию 8 hex-символов).
 *
 * Повторяет то, как `@cian/mf-registry` генерирует `instance.id`. Используется как `placeId`
 * баннера: React `useId()` не подходит — независимые React-роуты разных сервисов на одной
 * странице выдают одинаковые `:r0:`-идентификаторы.
 */
export const generateRandomString = (length = 8): string => {
  const randomArray = new Uint8Array(length / 2);

  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(randomArray);
  } else {
    randomArray.forEach((_, index) => {
      randomArray[index] = Math.floor(Math.random() * 256);
    });
  }

  return Array.from(randomArray, dec2hex).join('');
};
